



























































































































































import { Component, Vue } from 'vue-property-decorator';
import ProcessNumberCard from '@/components/myDashboard/ProcessNumberCard.vue';

@Component({
  components: {
    ProcessNumberCard,
  },
})
export default class ProcessNumberBase extends Vue {
  private workProcsses = [
    {
      number: 56,
      text: '今月働いた時間',
      unit: '時間',
      lastMonth: 40,
    },
    {
      number: 28,
      text: '今月稼いだお金',
      unit: '万円',
      lastMonth: 35,
    },
    {
      number: 23,
      text: '今月完了したチケット',
      unit: 'チケット',
      lastMonth: 40,
    },
  ];
  private openpen = false;
}
